import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap';

export class ExportButton extends Component {
  static propTypes = {
    onClick: PropTypes.func
  }

  toolTip() {
    return (
      <Tooltip className='in tooltip-siteone' id='tooltip-change-column'>
        <span>Export</span>
      </Tooltip>
    );
  }

  render() {
    return <div className='export-btn-box'>
      <OverlayTrigger placement='bottom' overlay={this.toolTip()}>
        <button className='export-btn icon-excel-export-ic' onClick={this.props.onClick} >
          <div className='export-img' />
        </button>
      </OverlayTrigger>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/ExportButton.js